import CardAvatar from './CardAvatar';

export default CardAvatar;
